import classes from "./css/footer.module.css";

const FooterTextArea = (props) => {
  return (
    <div>
      <div className={classes.footerSmallText}>{props.smallText}</div>
      <div className={classes.footerMainText}>{props.mainText}</div>
    </div>
  );
};

export default FooterTextArea;
